module.exports = __webpack_public_path__ + "static/media/gustavo.1773f29f.jpg";